import PropTypes from 'prop-types';

const ApiStatuses = {
  Loading: 'loading',
  Error: 'error',
  Loaded: 'loaded'
};

ApiStatuses.All = [ApiStatuses.Loading, ApiStatuses.Error, ApiStatuses.Loaded];
ApiStatuses.propType = PropTypes.oneOf(ApiStatuses.All);

export { ApiStatuses };



// WEBPACK FOOTER //
// ./src/api/constants.js